import { __makeTemplateObject } from 'tslib';
import { css } from 'styled-components';
import { font } from '../../../../theme/reset/index.js';

var baseStyles = function baseStyles(theme) {
  return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  &.fi-month-table {\n    ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n\n  & .fi-month-table_thead-cell {\n    padding: 1px;\n    text-align: center;\n    min-width: 36px;\n    height: 38px;\n  }\n"], ["\n  &.fi-month-table {\n    ", ";\n    margin-top: ", ";\n    margin-bottom: ", ";\n  }\n\n  & .fi-month-table_thead-cell {\n    padding: 1px;\n    text-align: center;\n    min-width: 36px;\n    height: 38px;\n  }\n"])), font(theme)('bodyTextSmall'), theme.spacing.s, theme.spacing.xs);
};
var templateObject_1;

export { baseStyles };
//# sourceMappingURL=MonthTable.baseStyles.js.map
